import { detectOS } from "@cosine/lib/utils/system/detectOS";
import { detectPlatform } from "@cosine/lib/utils/system/detectPlatform";
import { Platform } from "@cosine/lib/utils/system/detectPlatform.types";

export default function () {
  return {
    "X-Platform": [detectOS(), detectPlatform() === Platform.MobileNative ? "Native" : "Web"].join(" "),
  };
}
